/* Optional local preference; the device's reduced-motion setting always takes priority. */
(function(){
  var media=matchMedia('(prefers-reduced-motion: reduce)'),systemReduced=media.matches,saved=false;
  try{saved=localStorage.getItem('ms-reduce-motion')==='true';}catch(_){}
  var controls=document.querySelectorAll('[data-motion-reduce]');
  function apply(){
    var reduced=systemReduced || saved;
    document.documentElement.toggleAttribute('data-reduce-motion',reduced);
    document.querySelectorAll('[data-motion-settings]').forEach(function(node){node.hidden=false;});
    controls.forEach(function(control){control.checked=reduced;control.disabled=systemReduced;});
    document.querySelectorAll('[data-motion-system]').forEach(function(node){node.hidden=!systemReduced;});
    document.dispatchEvent(new CustomEvent('met:motionpreference',{detail:{reduced:reduced}}));
  }
  controls.forEach(function(control){control.addEventListener('change',function(){saved=control.checked;try{localStorage.setItem('ms-reduce-motion',String(saved));}catch(_){}apply();});});
  if(media.addEventListener)media.addEventListener('change',function(event){systemReduced=event.matches;apply();});
  apply();
})();
